import { QUERY_KEYS } from 'api/query-keys';
import { documentsService } from 'hq/services';
import { useMutation, useQueryClient } from 'react-query';

type SignDocumentParams = {
  documentId: string;
  dynamicProperties: Record<string, unknown>;
  contractMinutes: number;
  workerId: string;
};

export const useSignDocument = () => {
  const mutationFn = async ({
    documentId,
    dynamicProperties,
    contractMinutes,
    workerId,
  }: SignDocumentParams) => {
    await documentsService.signDocument(documentId, dynamicProperties, contractMinutes, workerId);
  };

  const queryClient = useQueryClient();

  return useMutation(mutationFn, {
    onSuccess: () => {
      queryClient.invalidateQueries(QUERY_KEYS.documents());
    },
  });
};
